import React, { useEffect, useMemo, useRef, useState } from "react";
import { getUser } from "../../services/Auth";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { api_url_estabelecimentos_image } from "../../providers/api";

import "./styles.css";
import { Edit } from "@material-ui/icons";
import {
  CadastrarInformacao,
  EditarInformacoes,
  EditarSenha,
} from "../../providers/EstabelecimentoProvider";
import { toast } from "react-toastify";

function Perfil() {
  const [estabelecimento, setEstabelecimento] = useState();
  const [modalSenhaVisible, setModalSenhaVisible] = useState(false);
  const [modalCodigoVisible, setModalCodigoVisible] = useState(false);
  const [modalInformacoesVisible, setModalInformacoesVisible] = useState(false);
  const [errorForm, setErrorForm] = useState("");

  const bannerInputRef = useRef();
  const profileImageInputRef = useRef();

  const { profileImageUrl, bannerImageUrl } = useMemo(
    () => ({
      profileImageUrl:
        api_url_estabelecimentos_image + estabelecimento?.foto_estabelecimento,
      bannerImageUrl:
        api_url_estabelecimentos_image + estabelecimento?.informacoes_adicionais?.banner,
    }),
    [estabelecimento],
  );

  useEffect(() => {
    async function handle() {
      const user = await getUser();
      setEstabelecimento(user.estabelecimento);
    }
    handle();
  }, []);

  const handleSubmitAlterarSenha = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const { password, passwordConfirm } = event.target.elements;
    if (password.value !== passwordConfirm.value) {
      return setErrorForm("As senhas devem ser iguais");
    }
    try {
      const response = await EditarSenha(password.value);
      if (response) {
        toast.success("Senha alterada com sucesso", "success");
        setModalSenhaVisible(false);
      }
    } catch (error) {
      toast.error("Erro ao alterar senha", "danger");
    } finally {
      setErrorForm("");
    }
  };

  const handleSubmitAlterarCodigo = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const { code, codeConfirm } = event.target.elements;
    if (code.value !== codeConfirm.value) {
      return setErrorForm("Os códigos devem ser iguais");
    }
    let form = new FormData();
    form.append("codigo_seguranca", code.value);
    try {
      const response = await EditarInformacoes(form);
      if (response) {
        toast.success("Código de segurança alterado com sucesso", "success");
        setModalCodigoVisible(false);
      }
    } catch (error) {
      toast.error("Erro ao alterar código de segurança", "danger");
    } finally {
      setErrorForm("");
    }
  };

  const handleSubmitAlterarInformacoes = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const { name, description } = event.target.elements;
    let form = new FormData();
    let infoForm = new FormData();
    form.append("nome_fantasia", name.value);
    infoForm.append("descricao", description.value);
    try {
      const response = await EditarInformacoes(form);
      const infoResponse = await CadastrarInformacao(infoForm);
      if (response && infoResponse) {
        toast.success("Informações alteradas com sucesso", "success");
        window.location.reload();
      }
    } catch (error) {
      toast.error("Erro ao alterar informações", "danger");
    } finally {
      setErrorForm("");
    }
  };

  const handleAlterarBanner = async (event) => {
    const image = event.target.files[0];
    let form = new FormData();
    form.append("imagem", image);
    try {
      const response = await CadastrarInformacao(form);
      if (response) {
        toast.success("Banner alterado com sucesso", "success");
        window.location.reload();
      }
    } catch (error) {
      toast.error("Erro ao alterar banner", "danger");
    } finally {
      setErrorForm("");
    }
  };

  const handleAlterarProfileImage = async (event) => {
    const image = event.target.files[0];
    let form = new FormData();
    form.append("imagem", image);
    try {
      const response = await EditarInformacoes(form);
      if (response) {
        toast.success("Imagem de perfil alterada com sucesso", "success");
        window.location.reload();
      }
    } catch (error) {
      toast.error("Erro ao alterar imagem de perfil", "danger");
    } finally {
      setErrorForm("");
    }
  };

  return (
    <div>
      <Row>
        <Col md={9}>
          <h3>Meu Perfil</h3>
        </Col>
        <Col>
          <Button onClick={() => setModalInformacoesVisible(true)}>
            Editar informações
          </Button>
        </Col>
      </Row>
      <input
        ref={profileImageInputRef}
        type="file"
        accept="image/x-png,image/gif,image/jpeg"
        hidden
        onChange={handleAlterarProfileImage}
      />
      <input
        ref={bannerInputRef}
        type="file"
        accept="image/x-png,image/gif,image/jpeg"
        hidden
        onChange={handleAlterarBanner}
      />
      <br></br>
      <Row style={{ flexDirection: "column", alignContent: "center" }}>
        <h4>Banner</h4>
        <div className="profile-banner">
          <img src={bannerImageUrl} alt="banner" />
          <Button
            size="sm"
            className="profile-edit-image-btn"
            onClick={() => bannerInputRef?.current?.click()}
          >
            <Edit />
          </Button>
        </div>
        <br></br>
        <h4>Perfil da loja</h4>
        <div className="profile-header">
          <div className="profile-image">
            <img src={profileImageUrl} alt="profile" />
            <Button
              size="sm"
              className="profile-edit-image-btn"
              onClick={() => profileImageInputRef?.current?.click()}
            >
              <Edit />
            </Button>
          </div>
          <div>
            <h5>{estabelecimento?.nome_fantasia}</h5>
            <p>{estabelecimento?.informacoes_adicionais?.descricao}</p>
          </div>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <h4>Configurações de acesso</h4>
        <br></br>
        <Row>
          <Col>
            <Button
              variant="primary"
              onClick={() => setModalSenhaVisible(true)}
              style={{ float: "left" }}
            >
              Alterar Senha
            </Button>
            <Button
              variant="primary"
              onClick={() => setModalCodigoVisible(true)}
              style={{ float: "left", marginLeft: "10px" }}
            >
              Alterar Código de Segurança
            </Button>
          </Col>
        </Row>
        <br></br>
        <br></br>
      </Row>

      <Modal size="l" show={modalSenhaVisible} onHide={() => setModalSenhaVisible(false)}>
        <Form onSubmit={handleSubmitAlterarSenha}>
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>Editar Senha</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Digite a nova senha: </Form.Label>
                  <Form.Control
                    required
                    type="password"
                    name="password"
                    placeholder="Senha"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Digite novamente a senha: </Form.Label>
                  <Form.Control
                    required
                    type="password"
                    name="passwordConfirm"
                    placeholder="Senha"
                  />
                </Form.Group>
                {errorForm ? (
                  <div>
                    <p style={{ color: "red" }}>{errorForm}</p>
                  </div>
                ) : null}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setModalSenhaVisible(false);
              }}
            >
              Fechar
            </Button>
            <Button type="submit" variant="primary" onClick={() => {}}>
              Confirmar Alterações
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        size="l"
        show={modalCodigoVisible}
        onHide={() => setModalCodigoVisible(false)}
      >
        <Form onSubmit={handleSubmitAlterarCodigo}>
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title> Editar Codigo de Segurança </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Digite o Novo código de segurança: </Form.Label>
                  <Form.Control
                    required
                    type="password"
                    placeholder="Código de segurança"
                    name="code"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Digite novamente o novo código de segurança: </Form.Label>
                  <Form.Control
                    required
                    type="password"
                    placeholder="Código de segurança"
                    name="codeConfirm"
                  />
                </Form.Group>
                {errorForm ? (
                  <div>
                    <p style={{ color: "red" }}>{errorForm}</p>
                  </div>
                ) : null}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setModalCodigoVisible(false);
              }}
            >
              Fechar
            </Button>
            <Button type="submit" variant="primary">
              Confirmar Alterações
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        size="l"
        show={modalInformacoesVisible}
        onHide={() => setModalInformacoesVisible(false)}
      >
        <Form onSubmit={handleSubmitAlterarInformacoes}>
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>Editar Informações</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Nome da loja: </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Nome da loja"
                    name="name"
                    maxLength={100}
                    defaultValue={estabelecimento?.nome_fantasia}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Descrição da loja: </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Descrição"
                    name="description"
                    maxLength={200}
                    defaultValue={estabelecimento?.informacoes_adicionais?.descricao}
                  />
                </Form.Group>
                {errorForm ? (
                  <div>
                    <p style={{ color: "red" }}>{errorForm}</p>
                  </div>
                ) : null}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setModalInformacoesVisible(false);
              }}
            >
              Fechar
            </Button>
            <Button type="submit" variant="primary">
              Confirmar Alterações
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default Perfil;
